import React from "react";

const StruggleSection = () => {
  return (
    <section className="section" style={{ background: "#050505" }}>
      <div className="container" style={{ textAlign: "center" }}>
        <h2 className="h-title" style={{ maxWidth: 900, margin: "0 auto" }}>
          Você não precisa de <span className="yellow">sorte</span>, nem de “<span className="yellow">viral aleatório</span>”.
        </h2>
        <div style={{ maxWidth: 780, margin: "36px auto 0", color: "rgba(255,255,255,0.8)", fontSize: 17, lineHeight: 1.8 }}>
          <p>Você posta, se esforça, cria conteúdo… mas não consegue transformar isso em dinheiro.</p>
          <p style={{ marginTop: 18 }}>Falta clareza. Falta direção. Falta saber o que realmente funciona.</p>
          <p style={{ marginTop: 18 }}>E o pior: <strong className="yellow">Você tá tentando crescer sozinho num jogo que é feito pra quem tem sistema.</strong></p>
        </div>
      </div>
    </section>
  );
};

export default StruggleSection;
